import { exportTargetsByType, exportType } from '../constants';
import type { AudienceForm, ExportTarget } from '../types';
import { shouldShowTargetIdTypes } from './marketOperatorRestrictions';

export const getSelectedExportTargets = (exportTargets: AudienceForm['export_targets']): ExportTarget[] => {
  return (Object.keys(exportTargets) as ExportTarget[]).reduce<ExportTarget[]>((acc, key) => {
    if (exportTargets[key]) {
      acc.push(key);
    }

    return acc;
  }, []);
};

/**
 * Target ID types are hidden for non-US markets, so values selected earlier (e.g. while US was chosen)
 * must not leak into the payload. In that case the export type defaults are submitted instead.
 */
export const getSubmittedExportTargets = (
  values: Pick<AudienceForm, 'export_type' | 'export_targets' | 'normalized_definition'>
): ExportTarget[] => {
  const { export_type: exportTypeValue, export_targets: exportTargets, normalized_definition } = values;
  const isHiddenForNonUsMarket =
    !!exportTypeValue &&
    exportTypeValue !== exportType.BIDSTREAM &&
    !shouldShowTargetIdTypes(exportTypeValue, normalized_definition);

  return getSelectedExportTargets(isHiddenForNonUsMarket ? exportTargetsByType[exportTypeValue] : exportTargets);
};
